/* =========================================================================
   FLASH PROMO — POP-UP DO 3º TOP GRÁTIS + GUARDA (01/10/2026)

   Vive na gaveta do carrinho (snippets/cart-drawer.liquid), então vale no
   site inteiro enquanto a campanha estiver no ar: o snippet
   tp-flash-promo-popup.liquid só emite este arquivo com a coleção
   `flash-promo` ativa e `countdown_fim` no futuro.

   A REGRA
   pagos  = unidades do Top Basic Flash Promo no carrinho SEM a propriedade
            `_flash_gratis`
   gratis = unidades COM a propriedade
   devidos = floor(pagos / 2)

   - devidos > gratis  -> abre o pop-up pedindo cor e tamanho do grátis
                          (uma peça por vez; se ainda faltar, abre de novo).
                          "Escolher depois" cala o pop-up até `pagos` mudar.
   - gratis > devidos  -> GUARDA: tira o excesso do carrinho (ela tirou um
                          dos pagos; o grátis sem par sairia cobrado).

   O desconto (compre 2, ganhe 1 a 100%) é do admin. Aqui só se garante que o
   carrinho tenha exatamente as peças que a oferta promete.

   COMO ACOMPANHA: embrulha o fetch e, depois de /cart/add|change|update|clear,
   relê /cart.js (igual ao lembrete do Fecha Mês). Na primeira carga também lê.
   ========================================================================= */
(function () {
  if (window.__tpFpp) return;
  window.__tpFpp = true;

  var dadosEl = document.querySelector('[data-tp-fpp-data]');
  var raiz = document.querySelector('[data-tp-fpp]');
  if (!dadosEl || !raiz) return;
  var D;
  try { D = JSON.parse(dadosEl.textContent); } catch (e) { return; }
  if (!D.productId || !D.variants || !D.variants.length) return;
  if (D.fim && Date.now() / 1000 > D.fim) return;

  var PROP = '_flash_gratis';
  var CORES_HEX = { preto: '#1a1a1a', branco: '#f3f2ee', bosque: '#3f5a3b', cereja: '#c50b39', 'café': '#7b4a2d', cafe: '#7b4a2d', 'azul marinho': '#2c3e6b', bege: '#d9c6b0', verde: '#6b7f5a', 'azul claro': '#9bb7d4' };
  var fetchOriginal = window.fetch;
  var ci = D.colorIndex, si = D.sizeIndex;
  var q = function (s) { return raiz.querySelector(s); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function semAcento(s) { s = String(s || ''); return (s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s).toLowerCase(); }
  function variante(cor, tam) { for (var i = 0; i < D.variants.length; i++) { var v = D.variants[i]; if ((ci < 0 || v.options[ci] === cor) && (si < 0 || v.options[si] === tam)) return v; } return null; }
  function corDisponivel(cor) { return D.variants.some(function (v) { return v.available && (ci < 0 || v.options[ci] === cor); }); }
  function fotoDaCor(cor) { for (var i = 0; i < D.variants.length; i++) { var v = D.variants[i]; if ((ci < 0 || v.options[ci] === cor) && v.img) return v.img; } return D.capa; }

  var st = { cor: (D.cores.filter(corDisponivel)[0]) || D.cores[0] || null, tam: null, aberto: false, ocupado: false, pagosVistos: null };
  var dispensado = null;
  try { dispensado = sessionStorage.getItem('tp-fpp-dispensado'); } catch (e) {}

  /* ---------- lembrete do 2º (cartão de rodapé) ---------- */
  var lemb = document.querySelector('[data-tp-fpl]');
  var lembAberto = false, lembDispensado = null;
  try { lembDispensado = sessionStorage.getItem('tp-fpl-dispensado'); } catch (e) {}
  function lembAbrir(pagos) {
    if (!lemb || lembAberto || String(lembDispensado) === String(pagos)) return;
    [].slice.call(document.querySelectorAll('[data-tp-fpl]')).forEach(function (el) { if (el !== lemb) el.parentNode.removeChild(el); });
    if (lemb.parentElement !== document.body) document.body.appendChild(lemb);
    lembAberto = true; lemb.hidden = false; void lemb.offsetWidth; lemb.classList.add('is-aberto');
    /* A OFERTA MANDA (08/10/2026): os cartoes da roleta saem de cena enquanto este esta aberto. */
    try { document.dispatchEvent(new CustomEvent('tp-oferta-cartao', { detail: { aberto: true, quem: 'flash-promo' } })); } catch (e) {}
  }
  function lembFechar(dispensar, pagos) {
    if (dispensar) { lembDispensado = pagos; try { sessionStorage.setItem('tp-fpl-dispensado', String(pagos)); } catch (e) {} }
    if (!lembAberto) return;
    lembAberto = false; lemb.classList.remove('is-aberto');
    setTimeout(function () { if (!lembAberto) lemb.hidden = true; }, 240);
    try { document.dispatchEvent(new CustomEvent('tp-oferta-cartao', { detail: { aberto: false, quem: 'flash-promo' } })); } catch (e) {}
  }
  if (lemb) {
    lemb.querySelector('[data-fpl-nao]').addEventListener('click', function () { lembFechar(true, st.pagosVistos); });
    lemb.querySelector('[data-fpl-sim]').addEventListener('click', function (ev) {
      /* já na PDP da Flash Promo: fecha a gaveta e leva à caixa de compra, sem recarregar */
      var caixa = document.querySelector('[data-tp-fp]');
      if (!caixa) return;
      ev.preventDefault();
      var g = gaveta(); if (g && typeof g.close === 'function') g.close();
      lembFechar(false);
      var r3 = caixa.querySelector('input[name="tp-fp-modo"][value="3"]'); if (r3 && !r3.checked) { r3.checked = true; r3.dispatchEvent(new Event('change', { bubbles: true })); }
      setTimeout(function () { caixa.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 150);
    });
  }

  /* ---------- leitura do carrinho ---------- */
  function lerCarrinho() { return fetchOriginal('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function contar(c) {
    var pagos = 0, gratis = 0, linhasGratis = [];
    (c.items || []).forEach(function (it) {
      if (String(it.product_id) !== String(D.productId)) return;
      if (it.properties && it.properties[PROP]) { gratis += it.quantity; linhasGratis.push(it); } else pagos += it.quantity;
    });
    return { pagos: pagos, gratis: gratis, linhasGratis: linhasGratis };
  }

  function gaveta() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
  function comSecoes(corpo) {
    var g = gaveta();
    if (g && typeof g.getSectionsToRender === 'function') { corpo.sections = g.getSectionsToRender().map(function (s) { return s.id; }); corpo.sections_url = window.location.pathname; }
    return corpo;
  }
  function redesenha(res) { var g = gaveta(); if (g && typeof g.renderContents === 'function' && res && res.sections) { if (g.classList.contains('is-empty')) g.classList.remove('is-empty'); g.renderContents(res); } }

  /* ---------- guarda: grátis a mais sai ---------- */
  function guardar(cont) {
    var excesso = cont.gratis - Math.floor(cont.pagos / 2);
    if (excesso <= 0) return Promise.resolve(false);
    var linha = cont.linhasGratis[cont.linhasGratis.length - 1];
    if (!linha) return Promise.resolve(false);
    var nova = Math.max(0, linha.quantity - excesso);
    st.ocupado = true;
    return fetchOriginal((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(comSecoes({ id: linha.key, quantity: nova }))
    }).then(function (r) { return r.json(); }).then(function (res) { redesenha(res); return true; })
      .catch(function () { return false; })
      .finally(function () { st.ocupado = false; });
  }

  /* ---------- avaliação ---------- */
  function avaliar(forcarAbrir) {
    if (st.ocupado) return;
    lerCarrinho().then(function (c) {
      var cont = contar(c);
      var devidos = Math.floor(cont.pagos / 2);
      if (cont.gratis > devidos) { guardar(cont).then(function (mexeu) { if (mexeu) setTimeout(function () { avaliar(false); }, 500); }); return; }
      if (st.pagosVistos !== null && st.pagosVistos !== cont.pagos) { dispensado = null; try { sessionStorage.removeItem('tp-fpp-dispensado'); } catch (e) {} }
      st.pagosVistos = cont.pagos;
      var faltam = devidos - cont.gratis;
      if (faltam > 0 && (forcarAbrir || String(dispensado) !== String(cont.pagos))) abrir(faltam);
      else if (faltam <= 0 && st.aberto) fechar(false);
      /* lembrete: pagos ímpar (1, ou 3 com um grátis já no carrinho) e nada faltando do grátis */
      if (faltam <= 0 && cont.pagos % 2 === 1 && !st.aberto) lembAbrir(cont.pagos); else lembFechar(false);
    }).catch(function () {});
  }

  function rota(url) {
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    if (u.indexOf('/cart/add') !== -1) return 'add';
    if (u.indexOf('/cart/change') !== -1 || u.indexOf('/cart/update') !== -1 || u.indexOf('/cart/clear') !== -1) return 'mudou';
    return '';
  }
  window.fetch = function (url) {
    var tipo = rota(url);
    var p = fetchOriginal.apply(this, arguments);
    if (tipo) {
      p.then(function (r) {
        if (!r || !r.ok) return;
        var daCaixa = window.__tpFpAdicao && (Date.now() - window.__tpFpAdicao.ts) < 15000 && window.__tpFpAdicao.modo === 3;
        if (daCaixa) { try { window.__tpFpAdicao = null; } catch (e) {} }
        setTimeout(function () { avaliar(!!daCaixa); }, daCaixa ? 500 : 700);
      }).catch(function () {});
    }
    return p;
  };
  lerCarrinho().then(function (c) { var cont = contar(c); st.pagosVistos = cont.pagos; var devidos = Math.floor(cont.pagos / 2); if (cont.gratis > devidos) guardar(cont); else if (devidos - cont.gratis > 0 && String(dispensado) !== String(cont.pagos)) abrir(devidos - cont.gratis); else if (cont.pagos % 2 === 1) lembAbrir(cont.pagos); }).catch(function () {});

  /* ---------- pop-up ---------- */
  var elCores = q('[data-fpp-cores]'), elTams = q('[data-fpp-tamanhos]'), elImg = q('[data-fpp-img]'), elSel = q('[data-fpp-sel]'), elBtn = q('[data-fpp-add]'), elN = q('[data-fpp-n]'), elErro = q('[data-fpp-erro]');
  function desenha() {
    if (ci > -1) {
      elCores.innerHTML = D.cores.map(function (cor) {
        var disp = corDisponivel(cor); var hex = CORES_HEX[semAcento(cor)] || '#ccc';
        return '<button type="button" class="tp-fpp__cor' + (st.cor === cor ? ' is-sel' : '') + (disp ? '' : ' is-esgotada') + '" data-fpp-cor="' + esc(cor) + '" role="radio" aria-checked="' + (st.cor === cor) + '" aria-label="' + esc(cor) + (disp ? '' : ' (esgotada)') + '" title="' + esc(cor) + '"><span class="tp-fpp__cor-bolha" style="background:' + hex + '"><img src="' + esc(D.swatches[cor] || '') + '" alt="" onerror="this.remove()"></span></button>';
      }).join('');
    }
    if (si > -1) {
      elTams.innerHTML = D.tamanhos.map(function (tam) {
        var v = variante(st.cor, tam); var ok = v && v.available;
        return '<button type="button" class="tp-fpp__tam' + (st.tam === tam ? ' is-sel' : '') + (ok ? '' : ' is-esgotado') + '" data-fpp-tam="' + esc(tam) + '" role="radio" aria-checked="' + (st.tam === tam) + '"' + (ok ? '' : ' aria-disabled="true"') + '>' + esc(tam) + '</button>';
      }).join('');
    }
    if (elImg) elImg.src = fotoDaCor(st.cor);
    if (elSel) elSel.textContent = (st.cor || '') + (st.tam ? ' · ' + st.tam : '');
    var v = st.tam ? variante(st.cor, st.tam) : null;
    elBtn.classList.toggle('is-espera', !(v && v.available));
    q('[data-fpp-add-label]').textContent = v && v.available ? 'Adicionar meu top grátis' : 'Escolha o tamanho';
  }
  function abrir(faltam) {
    if (st.aberto) { desenha(); return; }
    st.aberto = true;
    lembFechar(false);
    if (elN) elN.textContent = faltam > 1 ? 'Você tem ' + faltam + ' tops grátis para escolher' : 'Seu 3º Top Basic sai de graça';
    desenha();
    /* a gaveta redesenha e traz outra cópia (escondida) desta marcação; só a nossa fica */
    [].slice.call(document.querySelectorAll('[data-tp-fpp]')).forEach(function (el) { if (el !== raiz) el.parentNode.removeChild(el); });
    if (raiz.parentElement !== document.body) document.body.appendChild(raiz);
    raiz.hidden = false;
    void raiz.offsetWidth;
    raiz.classList.add('is-open');
    document.documentElement.classList.add('tp-fpp-aberto');
    var s = raiz.querySelector('.tp-fpp__sheet'); if (s) try { s.focus({ preventScroll: true }); } catch (e) {}
  }
  function fechar(dispensar) {
    if (!st.aberto) return;
    st.aberto = false;
    if (dispensar) { dispensado = st.pagosVistos; try { sessionStorage.setItem('tp-fpp-dispensado', String(st.pagosVistos)); } catch (e) {} }
    raiz.classList.remove('is-open');
    document.documentElement.classList.remove('tp-fpp-aberto');
    setTimeout(function () { if (!st.aberto) raiz.hidden = true; }, 260);
  }

  raiz.addEventListener('click', function (ev) {
    var c = ev.target.closest('[data-fpp-cor]'), t = ev.target.closest('[data-fpp-tam]');
    if (c) { st.cor = c.getAttribute('data-fpp-cor'); var v0 = variante(st.cor, st.tam); if (!v0 || !v0.available) st.tam = null; desenha(); return; }
    if (t) { if (t.getAttribute('aria-disabled') === 'true') return; st.tam = t.getAttribute('data-fpp-tam'); desenha(); return; }
    if (ev.target.closest('[data-fpp-fechar]') || ev.target === raiz.querySelector('.tp-fpp__overlay')) fechar(true);
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && st.aberto) fechar(true); });

  elBtn.addEventListener('click', function () {
    var v = st.tam ? variante(st.cor, st.tam) : null;
    if (!v || !v.available) { if (elTams) { elTams.classList.add('is-pisca'); setTimeout(function () { elTams.classList.remove('is-pisca'); }, 900); } return; }
    elBtn.disabled = true; elErro.hidden = true; st.ocupado = true;
    var props = {}; props[PROP] = '3º Top Basic grátis';
    fetchOriginal((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(comSecoes({ items: [{ id: v.id, quantity: 1, properties: props }] }))
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status) throw new Error(res.description || res.message || 'Não foi possível adicionar.');
      redesenha(res);
      var g = gaveta(); if (g && typeof g.open === 'function') g.open();
      fechar(false);
      st.tam = null;
      setTimeout(function () { st.ocupado = false; avaliar(false); }, 600);
    }).catch(function (err) { st.ocupado = false; elErro.textContent = (err && err.message) || 'Não foi possível adicionar. Tente de novo.'; elErro.hidden = false; })
      .finally(function () { elBtn.disabled = false; });
  });
})();
